import { Fragment } from 'react';
import styled from 'styled-components';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedTextProps } from '@mews/framework';
import { Divider, Stack } from '@optimus-web/core';
import { LocalizedLabel } from '../localization';

export interface CardEntry extends Pick<LocalizedTextProps, 'textKey' | 'substitutes'> {
    value: React.ReactNode;
    valueOnNewLine?: boolean;
}

export interface CardEntriesProps {
    entries: CardEntry[];
    entryFallbackValue?: React.ReactNode;
}

export const CardEntries: React.FC<CardEntriesProps> = ({ entries, entryFallbackValue = UnicodeEntity.Dash }) => (
    <Stack vertical spacing="100">
        {entries.map(({ textKey, substitutes, value, valueOnNewLine }, index) => (
            <Fragment key={textKey}>
                <Stack
                    wrap
                    vertical={!!valueOnNewLine && !!value}
                    spacing="100"
                    distribution="space-between"
                    data-test-card-entry={textKey}
                >
                    <LocalizedLabel textKey={textKey} substitutes={substitutes} variant="secondary" as="div" />
                    <ValueWrapper>{value ?? entryFallbackValue}</ValueWrapper>
                </Stack>

                {index < entries.length - 1 && <Divider />}
            </Fragment>
        ))}
    </Stack>
);

const ValueWrapper = styled.div`
    white-space: pre-line;
    text-overflow: ellipsis;
    overflow: hidden;
`;
